import { Checkbox as CheckboxMUI, useMediaQuery } from "@mui/material";

import { useTypedTheme } from "hooks";
import { palette } from "theme/palette";

type Props = {
  onChange: (checked: boolean) => void;
  checked: boolean;
  isRoundCheck?: boolean;
};

export const Checkbox = ({
  onChange,
  checked,
  isRoundCheck = false,
}: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const isMobile = useMediaQuery(down("sm"));

  return (
    <CheckboxMUI
      sx={{
        top: isRoundCheck ? (isMobile ? 20 : 10) : 0,
        color: palette.grey,
        "&.Mui-checked": {
          color: palette.accent,
        },
      }}
      onChange={(e) => onChange(e.target.checked)}
      checked={checked || false}
    />
  );
};
